import { useContext } from 'react';

import { Context } from './context';
import type { BannerContextData } from './context';

export const useBanner = (): BannerContextData => useContext(Context);
